export enum ActionTypes {
  ADD_ITEM = "ADD_ITEM",
  REMOVE_ITEM = "REMOVE_ITEM",
  UPDATE_ITEM_QUANTITY = "UPDATE_ITEM_QUANTITY",
  CLEAR_CART = "CLEAR_CART",
}
